import {PureComponent} from 'react'
import template from './radioList.rt';
import _ from 'lodash';

const createItemList = (items) => {
  if(!items || items.length == 0) {
    return [];
  }
  let itemList = [];
  items.forEach(item => {
    if(item.text && item.value) {
      itemList.push(item);
    } else if(item.text) {
      itemList.push({text: item.text, value: item.text, selected: item.selected || false});
    } else if(item.value) {
      itemList.push({text: item.value, value: item.value, selected: item.selected || false});
    } else {
      itemList.push({text: item, value: item, selected: item.selected || false});
    }
  });
  return itemList;
}

class RadioList extends PureComponent {
  constructor(props) {
    super(props);

    let items = createItemList(props.items || []);

    let selected = _.find(items, i => i.selected);
    if(!props.allowNone && !selected && items.length > 0) {
      items[0].selected = true;
      selected = items[0];
    }

    this.state = {
      items
    };
    
    if(props.onSelect) 
      props.onSelect(selected, items);
  }

  handleSelectItem = (selectedItem) => {
    let items = [...this.state.items]
      , item = _.find(items, i => i.value == selectedItem.value);
    
    if(!item.selected || (this.props.allowNone || items.filter(i => i.selected).length > 1)) {
      if(!this.props.multiple && !item.selected)
        items.forEach(i => i.selected = false);
      item.selected = !item.selected;
    }

    this.setState({items}, () => {
      if(this.props.onSelect) 
        this.props.onSelect(item, items);
    });
  }

  render = template;
}

export default RadioList;
export {RadioList};
